import React, { useEffect,useState,useRef,cloneElement } from 'react';
import Tooltip ,{ tooltipClasses } from '@mui/material/Tooltip';
import "../../cssfiles/homepage.css";

//input title is used to calculate the tooltip offset based on the visible text length, title is used for the actual tooltip content. This is done to handle cases where the displayed text is truncated and we want the tooltip to be positioned based on the visible portion of the text.
//inputTitle - text for which tooltip is applied on.
//title - text to be shown in tooltip. 
//incase if text in tooltip is different from the text on which tooltip is applied then pass both title and input title as props, if they are same then just pass title as prop.
//pass ifOverflow prop as true if you want to show tooltip only when text is truncated, by default tooltip will be shown on hover even if text is not truncated.

export default function CustomTooltip(props) {
    //where should the tooltip be placed //placement={props.placement?props.placement:'bottom-end'}
    const [offset, setOffset] = useState([0,0]); // Default offset
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
    if (textRef.current) {
            const element = textRef.current;
            const computedStyle = window.getComputedStyle(element);
            const font = `${computedStyle.fontSize} ${computedStyle.fontFamily}`;
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;

            // Measure the full text width
            const fullTextWidth = context.measureText(props.title).width;

            // Measure the visible width of the element
            const visibleWidth = element.offsetWidth;

            // Calculate the visible length of the text
            let visibleText = "";
            let currentWidth = 0;
            let titleToMeasure = props.title;
            if(props.inputTitle){
                titleToMeasure = props.inputTitle;
            }
            for (let i = 0; i < titleToMeasure.length; i++) {
                currentWidth += context.measureText(titleToMeasure[i]).width;
                if (currentWidth > visibleWidth) break;
                visibleText += titleToMeasure[i];
            }

            // Dynamically set the offset based on visible text length
            // setOffset([visibleText.length * (props.offset ? props.offset[0] : 10), props.offset ? props.offset[1] : -20]); // Adjust the multiplier as needed
            setOffset(props.offset ? props.offset : [0,0]); // Adjust the multiplier as needed
            
            if(element) {
                setIsOverflowing(element.scrollWidth > element.clientWidth);
            }
        }
    }, [props.title, props.inputTitle]);

    const clonedChild = React.isValidElement(props.children)
        ? cloneElement(props.children, { ref: textRef }) // Attach the ref to the child
        : props.children;

    return(
        <>
            <Tooltip title={props.title} placement={props.placement?props.placement:'bottom'} disableHoverListener={props.disableHoverListenerForTooltip!==undefined?props.disableHoverListenerForTooltip:(props.ifOverflow?!isOverflowing:false)} open={props.open} onClose={props.onClose?props.onClose:null} onOpen={props.onOpen?props.onOpen:null}
                    componentsProps={{
                        tooltip: {
                        sx: {
                            bgcolor: '#005c8e',
                            borderRadius: '0px 0px 0px 10px',
                            padding:"8px",
                            fontSize: '12px',
                            '& .MuiTooltip-arrow': {
                            color: '#ffffff',
                            },
                        },
                        },
                    }}   
                     slotProps={{
                        popper: {
                        modifiers: [
                            {
                            name: 'offset',
                            options: {
                                offset: offset,
                            },
                            },
                        ],
                        },
                    }} 
                >
                    {/* {props.children} */}
                    {clonedChild}
            </Tooltip>
        </>
    )
}